import React, { useState } from 'react';
import { HelpCircle, X, Send, Loader2, AlertCircle, MessageSquare } from 'lucide-react';
import { db } from '../../lib/firebase';
import { addDoc, collection } from 'firebase/firestore';
import { useAuth } from '../../contexts';

const SupportModal = ({ onClose }) => {
  const { user } = useAuth();
  const [subject, setSubject] = useState('');
  const [message, setMessage] = useState('');
  const [sent, setSent] = useState(false);
  const [isSending, setIsSending] = useState(false);

  const handleSend = async () => {
    if (!subject || !message) return;
    setIsSending(true);
    await new Promise(r => setTimeout(r, 800));
    try {
      await addDoc(collection(db, 'support_tickets'), {
        userId: user.uid,
        userEmail: user.email,
        subject,
        message,
        status: 'open',
        date: new Date().toISOString()
      });
      setSent(true);
      setTimeout(onClose, 2500);
    } catch (e) {
      console.error(e);
      setIsSending(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-slate-900/60 backdrop-blur-sm z-[60] flex items-center justify-center p-4 animate-in fade-in duration-200">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-lg overflow-hidden transform transition-all scale-100 relative">
        <div className="bg-gradient-to-r from-slate-800 to-slate-900 p-6 text-white flex justify-between items-start">
          <div>
            <h3 className="font-bold text-xl flex items-center gap-2">
              <HelpCircle size={24} className="text-blue-400" /> Besoin d'aide ?
            </h3>
            <p className="text-slate-400 text-sm mt-1">Notre équipe technique vous répond sous 24h.</p>
          </div>
          <button onClick={onClose} className="text-slate-400 hover:text-white transition bg-white/10 p-1.5 rounded-full">
            <X size={20} />
          </button>
        </div>

        {sent ? (
          <div className="p-12 text-center animate-in zoom-in duration-300 flex flex-col items-center">
            <div className="w-20 h-20 bg-green-100 text-green-600 rounded-full flex items-center justify-center mb-6 shadow-sm">
              <Send size={32} className="ml-1" />
            </div>
            <h3 className="text-2xl font-bold text-slate-800 mb-2">Message envoyé !</h3>
            <p className="text-slate-500">Demande prise en compte.</p>
          </div>
        ) : (
          <div className="p-6 space-y-5">
            <div>
              <label className="text-xs font-bold text-slate-500 uppercase mb-1.5 block ml-1">Sujet</label>
              <div className="relative">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none text-slate-400">
                  <AlertCircle size={18} />
                </div>
                <input
                  className="w-full border border-slate-200 bg-slate-50 rounded-xl pl-10 pr-4 py-3 outline-none focus:ring-2 focus:ring-blue-500 transition font-medium text-slate-700"
                  placeholder="Sujet..."
                  value={subject}
                  onChange={e => setSubject(e.target.value)}
                  autoFocus
                />
              </div>
            </div>
            <div>
              <label className="text-xs font-bold text-slate-500 uppercase mb-1.5 block ml-1">Message</label>
              <div className="relative">
                <div className="absolute top-3 left-3 pointer-events-none text-slate-400">
                  <MessageSquare size={18} />
                </div>
                <textarea
                  rows="5"
                  className="w-full border border-slate-200 bg-slate-50 rounded-xl pl-10 pr-4 py-3 outline-none focus:ring-2 focus:ring-blue-500 transition text-slate-700 resize-none"
                  placeholder="Détails..."
                  value={message}
                  onChange={e => setMessage(e.target.value)}
                />
              </div>
            </div>
            <div className="pt-4 flex justify-end gap-3">
              <button onClick={onClose} className="px-5 py-2.5 rounded-xl font-bold text-slate-500 hover:bg-slate-100 transition">
                Annuler
              </button>
              <button
                onClick={handleSend}
                disabled={!subject || !message || isSending}
                className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-2.5 rounded-xl font-bold shadow-lg hover:shadow-xl transition transform active:scale-95 flex items-center gap-2 disabled:opacity-70 disabled:cursor-not-allowed"
              >
                {isSending ? <><Loader2 size={18} className="animate-spin" /> Envoi...</> : <><Send size={18} /> Envoyer</>}
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default SupportModal;
